import { Text } from '@h2/components/typography/text'
import { Page } from '@h2/common/components/page'
import { Heading } from '@h2/components/typography/heading'

const TermsOfUse = () => {
  return (
    <Page>
      <Page.Title>2025 Headed2 General Terms of Use</Page.Title>
      <Page.Layout>
        <Page.Content>
          <Heading level={2}>
            PLEASE READ THROUGH THE WEBSITE TERMS OF USE CAREFULLY BEFORE USING THE SITE
          </Heading>
          <Text>
            PowerSchool Group LLC (“PowerSchool”) provides services (“Headed2”) is a
            comprehensive career exploration and planning tool designed to help students
            and job seekers prepare for their futures. It provides Explorers with access
            to information on various career paths, job opportunities, and educational
            requirements. The platform supports individualized career pathway planning
            through self- assessments, goal setting, and access to localized labor market
            data. Explorers can optionally connect with Navigators, who can help
            facilitate that process and guide their journey. Headed2 Services are
            available through an Internet site located at the URL address of Headed2.
            (“the site”). References to “us,” “we,” “our,” or “PowerSchool” in these Terms
            of Use, are referring to PowerSchool Group LLC and its affiliates. References
            to “you”, “your” or “User” in this Terms of Use document refers to the
            Explorers, i.e. the student/ children, and Navigators, unless mentioned
            specifically.
          </Text>
          <Heading level={3}>A. WHAT ARE TERMS OF USE?</Heading>
          <Text>
            This Terms of Use document (“ToU”) informs you of the rules for using the site
            and how PowerSchool collects and processes your personal data for Headed2.
            This general ToU is a general agreement between PowerSchool, licensor of
            Headed2 and the User (“you” or “your”) who avail any services from Headed2.
            Your use of this Site is subject to all terms and policies posted on this Site
            (including the Privacy Statement and Headed2 Privacy Supplement) or separately
            agreed to by you (collectively referred to as “Terms of Use” or “ToU”). Any
            undefined terms used in this ToU shall refer to areas of this site with the
            same name. The ToU may be revised from time to time through an updated
            posting, and therefore you should check the ToU periodically. Revisions are
            immediately effective upon posting and your continued use of this Site
            following the posting of revisions to the ToU will indicate your acceptance of
            such revisions. It is important to PowerSchool that this Site provides a
            helpful and reliable experience to Users. To protect our rights and yours, we
            have prepared these Terms of Use that apply to all visitors to this Site. If
            you have any questions concerning the ToU, please Contact Us. The site is a
            public site with free access for the Explorers with tools that help them
            develop career exploration skills, identify next steps, and plan for their
            future. Explorers can optionally connect with Navigators, who can help
            facilitate that process and guide their journey. PowerSchool assumes no
            liability for the quality and genuineness of guidance from the Navigators.
            PowerSchool does not monitor the responses that an explorer may receive in
            response to information he/she has displayed on the site/navigator.
          </Text>

          <Heading level={3}>B. CONSENT</Heading>
          <Text>
            1. BY USING OR ACCESSING THIS SITE OR UPLOADING OR DOWNLOADING INFORMATION TO
            AND FROM THIS SITE, YOU REPRESENT: AND GIVE YOUR CONSENT THAT: • YOU HAVE READ
            AND UNDERSTOOD THE ToU AND THE PRIVACY STATEMENT INCLUDING THE PRIVACY
            SUPPLEMENT AND AGREE TO BE BOUND BY THEM; • YOU AGREE TO USE THIS SITE IN A
            MANNER CONSISTENT WITH ALL APPLICABLE LAWS AND REGULATIONS AND IN ACCORDANCE
            WITH THIS ToU; • YOU ARE A VALID PERSON MEETING AGE AND OTHER REQUIREMENTS FOR
            ENTERING INTO AN AGREEMENT AND IN THE EVENT THAT YOU ARE A PARENT OR GUARDIAN
            OF A MINOR, YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL CAPACITY TO ACT
            ON BEHALF OF SUCH MINOR AND ACKNOWLEDGE AND AGREE THAT THE PROVISIONS OF THIS
            ToU WILL BE EQUALLY APPLICABLE TO THE MINOR. 2. BY USING OR ACCESSING THIS
            SITE OR UPLOADING OR DOWNLOADING INFORMATION TO AND FROM THIS SITE, YOU GRANT
            POWERSCHOOL TO YOUR VOLUNTARY CONSENT TO: • SHARE YOUR DATA WITH THE
            NAVIGATORS OR RESPECTIVE STATE CAREER EXPLORER PROGRAM WHEN: a) YOU SIGN UP
            FOR ANY STATE CAREER EXPLORER PROGRAM. AND b) WHEN WE RECEIVE CONFIRMATION OF
            YOUR PARENT/ GUARDIAN; • USE YOUR DATA WITHOUT ANY COMPENSATION TO YOU FOR
            PROCESSING THE DATA TO PROVIDE SERVICES TO YOU ON THE APPLICATION. • USE DATA
            AND INFORMATION YOU PROVIDE IN THE APPLICATION MAKE RELEVANT SUGGESTIONS AND
            RECOMMENDATION TO YOU.
            <strong>
              PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. IF YOU DO NOT AGREE WITH
              ANY PART OF THE ToU OR THE PRIVACY STATEMENT INCLUDING THE HEADED2 PRIVACY
              SUPPLEMENT GOVERNING THIS SITE, YOU SHOULD NOT USE THIS SITE. WHEN YOU
              ACCESS ANY SERVICES OF HEADED2 YOU ARE BOUND BY ALL OF THE ToU WHICH ARE
              INTENDED TO BE FULLY EFFECTIVE AND BINDING.
            </strong>
            If you are a navigator or a teacher at a school or school district acting on
            behalf of such school or school district, by registering on or logging into
            this site you are agreeing to these ToU and the Privacy Statement including
            the Headed2 Privacy Supplement on your own behalf and on behalf of such school
            or school district. A PRINTED VERSION OF THIS AGREEMENT AND ANY RELATED NOTICE
            GIVEN IN ELECTRONIC FORM SHALL BE ADMISSIBLE IN ANY JUDICIAL PROCEEDINGS TO
            THE SAME EXTENT AS ANY OTHER AGREEMENT ON PAPER OR PRINTED FORM.
            <strong>
              BY CLICKING ON “I ACCEPT” OR ANY SUCH CONNOTATION TO THE ELECTRONIC
              AGREEMENT, YOU ACCEPT THAT YOU DIGITALLY GIVE YOUR COMPLETE AND UNEQUIVOCAL
              CONSENT TO THE TERMS AND CONDITIONS OF THIS AGREEMENT.
            </strong>
            In addition to these ToU these additional terms, may also apply to you by use
            of the Site: Our Global Privacy Statement, which sets out the terms on which
            PowerSchool processes any personal data that is collected by use of any
            PowerSchool products. Our Cookie Notice, which sets out information about the
            cookies on our Products and related sites.
          </Text>
          <Heading level={4}>TERMS AND CONDITIONS APPLICABLE TO EXPLORER</Heading>
          <Text>
            The Explorer agrees to use the career explorer services with lawful intentions
            and agrees to provide only truthful information whenever required. If any
            information provided by the Explorer is found to be incorrect and deemed
            intentionally deceitful in nature, PowerSchool will not take any
            responsibility for the actions taken by the Navigators or the respective State
            Career Explorer Program against such Explorer. The Explorer understands that
            PowerSchool does not influence or have any association with the application
            review or career guidance processes of Navigators/ State Career Explorer
            Program. The Explorer agrees not to hold PowerSchool liable for the outcome of
            any application utilizing the Headed2 Services. The user undertakes to use
            Headed2 for his/her own purposes. Using content from Headed2 for derivative
            works with a commercial motive without prior written consent from PowerSchool
            is strictly prohibited. Where an Explorer wishes to participate in any state
            Career Explorer Program, an email will be sent to their Parent/ Guardian to
            confirm their approval and consent for the Explorer to access the program.
            Once approved by the Parent/Guardian, the data of the child with the selected
            state Career Explorer Program. In addition to the Terms and Conditions set
            forth in section C, and except as set forth in section D entitled “Terms and
            Conditions Applicable to Navigators”, the Candidate shall be subject to all
            provisions of Headed2 ToU, Global Privacy Statement and Headed2 Global Privacy
            Supplement.
          </Text>
          <Heading level={4}>TERMS AND CONDITIONS APPLICABLE TO NAVIGATORS</Heading>
          <Text>
            Headed2 Services allows Explorers to connect with the Navigators, who can help
            the Explorers facilitate that process and guide their journey and plan their
            future career skills. This agreement is entered into between PowerSchool and
            the Navigator as of the date the Navigator creates its account with the site
            in capacity as a navigator. The Navigator agrees to use the Services with
            lawful intentions and to guide the Explorer to plan their future career
            skills. Furthermore, the Navigator agrees to protect the security of the
            Explorer’s information stored/received by them while providing guidance to the
            Explorer. The Navigator understands that PowerSchool cannot be held
            responsible for lost data, or misrepresented information provided by Explorer
            who accessed the Services using appropriate authentication information. In
            addition to the Terms and Conditions set forth in section D, and except as set
            forth in section C entitled “Terms and Conditions Applicable to Explorer“, the
            Navigator shall be subject to all provisions of PowerSchool´s Headed2 ToU,
            Global Privacy Statement and Headed2 Global Privacy Supplement.
          </Text>
          <Heading level={4}>GENERALLY APPLICABLE SECTIONS</Heading>
          <Text>
            <strong>Access</strong>
            Access to some sections of this site is restricted to Explorer and/or
            Navigator. Usernames and passwords are personal to the registered user and may
            not be shared or transferred with any other party. Usernames and passwords are
            personal to the registered User and may not be shared or transferred with any
            other party. Usernames and passwords must be kept confidential.
            <strong>Registration</strong>
            PowerSchool products may require you to be a registered User. At the time of
            registration and thereafter at all the times you agree to provide accurate,
            true and up- to-date and complete information.
            <strong>User License</strong>
            Users of this site (each a “User” and collectively, “Users”) are granted,
            subject to this ToU, a personal, non-exclusive, non-assignable, and
            non-transferable license to access and use this Site for personal,
            non-commercial use. Modification of any materials on this Site or use of the
            materials for any purpose other than as contemplated in these ToU is a
            violation of PowerSchool’s copyright and proprietary rights. Except for the
            material you create in a Explorer Portfolio, career development guidance or
            other information you provide through the Headed2 Services or for any material
            you submit to the Headed2 Services, you may not reproduce, upload, post,
            transmit, download, or distribute any part of this site other than printing
            out or downloading portions of the text and images for your own personal,
            non-commercial use, without written approval of PowerSchool.
            <strong>Incorporation of Information on this Site</strong>
            The descriptions of the Headed2 Services and terms set forth on other areas of
            this site, including, without limitation, areas of this site relating to the
            registration of Explorer or Navigators as users hereof, are as set forth in
            such other areas and are expressly incorporated into these Terms of Use by
            reference.
            <strong>Information Accuracy</strong>
            The user has an obligation to provide true and correct information and always
            keep the data up to date. PowerSchool cannot guarantee the accuracy of
            information provided by Explorers or Navigators and therefore cannot be held
            responsible for any incorrect information presented in the Headed2 services.
            The information, software, products, and services published on this website
            may include inaccuracies or typographical errors. PowerSchool cannot be held
            responsible for complete information or flow not appearing due to faults in
            certain software, applications, or devices you may be using. In case a person
            using the world wide web/internet receives spam or virus which includes a link
            to headed2.com, PowerSchool should not be held responsible for the same.
            PowerSchool assumes no responsibility for such mails. The User(s) shall not
            upload, post, transmit, publish, or distribute any material or information
            that is unlawful, or which may potentially be perceived as being harmful,
            threatening, abusive, harassing, defamatory, vulgar, obscene, or racially,
            ethnically, or otherwise objectionable. The User(s) agrees to indemnify
            PowerSchool for all losses incurred by Headed2 or PowerSchool due to any
            false, distorted, manipulated, defamatory, vulgar, obscene, fraudulent, or
            misleading facts or otherwise objectionable averments made by the User on the
            site.
            <strong>Content</strong>
            PowerSchool does not guarantee the accuracy or completeness of any information
            or content posted by the User. You agree that you must evaluate, and bear all
            risks associated with, the use of any content, including any reliance on the
            accuracy, completeness, or usefulness of such content.
            <strong>Security</strong>
            You are responsible for maintaining the confidentiality of your username and
            password and are fully responsible for all activities that occur under your
            username and password. You agree to (a) immediately notify PowerSchool of any
            unauthorized use of your username and password, or another user´s username and
            password, or any other breach of security, and (b) ensure that you log out
            from use of this site under your username and password at the end of each
            session. PowerSchool cannot and will not be liable for any loss or damage
            arising from your failure to comply with these Terms of Use. PowerSchool does
            not ask for the username and password from the Users, in any manner other than
            to log onto the website.
            <strong>User Submissions</strong>
            As a user, you are responsible for your own communications and are responsible
            for the consequences of posting your data/ communications. You must not, and
            by using this site you agree not to, do the following things: post material
            that is copyrighted, unless you are the copyright owner or have the permission
            of the copyright owner to post it; post material that reveals trade secrets,
            unless you own them or have the permission of the owner; post material that
            infringes on any other intellectual property rights of others or on the
            privacy or publicity rights of others; post material that is obscene,
            defamatory, threatening, harassing, abusive, hateful, or embarrassing to
            another user or any other person or entity; post a sexually explicit image or
            statement; post advertisements or solicitations of business, post chain
            letters or pyramid schemes; impersonate another person; or post material that
            contains viruses, Trojan horses, worms, time bombs, cancelbots or other
            computer programming routines or engines that are intended to damage,
            detrimentally interfere with, surreptitiously intercept or expropriate any
            system, data or information your postings will not be used to carry out or
            solicit any unlawful activity and/or be used to make commercial solicitations
            PowerSchool does not represent or guarantee the truthfulness, accuracy, or
            reliability of communications posted by users or endorse any opinions
            expressed by users. You acknowledge that any reliance on material posted by
            other users will be at your own risk. PowerSchool acts as a passive conduit
            for the online distribution and publication of user-submitted information and
            has no obligation to screen communications or information in advance and is
            not responsible for screening or monitoring material posted by users. If
            notified by a user of communications which allegedly does not conform to these
            Terms of Use, PowerSchool may investigate the allegation and determine in good
            faith and its sole discretion whether to remove or request the removal of the
            communication. PowerSchool has no liability or responsibility to users for
            performance or nonperformance of such activities. Any hyperlinks, “hidden“
            keywords or any keywords that are irrelevant to the career guidance or are
            otherwise misleading contained in a career guidance are prohibited.
            PowerSchool always welcomes suggestions and comments regarding this Site from
            Users. Any comments or suggestions submitted to this Site or PowerSchool,
            either online or offline, will become PowerSchool’s property upon their
            submission and you shall not be entitled to any claim or compensation under
            any circumstances. This policy is intended to avoid the possibility of future
            misunderstandings when projects developed by PowerSchool might seem to others
            to be like their own submissions or comments.
            <strong>Service Availability</strong>
            The Headed2 Services are available 24 hours per day, 7 days per week through
            an Internet site. However, PowerSchool reserves the right to temporarily
            restrict access to the Headed2 Services to perform maintenance and system
            upgrades. PowerSchool has no obligation to notify the User prior to any system
            outages and cannot be held responsible for any inconveniences caused by the
            outage. PowerSchool reserves the right to employ artificial intelligence to
            respond to queries, or to handle portions of the user interface.
            <strong>Assignment</strong>
            You grant PowerSchool the right to assign this agreement to its affiliate or
            in connection with a merger, acquisition, or sale with an intimation on the
            website or to you. Users cannot assign services to any other person without
            prior written confirmation of PowerSchool.
            <strong>Unlawful Use</strong>
            As a condition of your use of this Site, you warrant to PowerSchool that you
            will not use this Site for any purpose that is unlawful or prohibited by the
            ToU. You agree not to upload, post, transmit, publish, or distribute or use
            any material or information in this Site that is unlawful, or which may
            potentially be perceived as being harmful, threatening, or objectionable in
            any manner that could damage, disable, overburden, or impair this Site or
            interfere with any other party’s use and enjoyment of this Site. You agree not
            to obtain or attempt to obtain through this Site any materials or information
            not intentionally made available to you through this Site.
            <strong>Software License</strong>
            Any software you download from this site will be governed by the terms of the
            user license agreement, if any, which accompanies or is included with the
            software. You may not install or use any software that is accompanied by or
            includes a license agreement unless you first agree to the terms of that
            license agreement. For any software not accompanied by a license agreement, we
            hereby grant to you, the user, a limited, personal, nontransferable, and
            nonexclusive license to use the software for your own personal, non-commercial
            use, in accordance with these Terms of Use and for no other purpose.
            <strong>Reverse Engineering Prohibited</strong>
            You agree not to reverse engineer, duplicate, publish, modify, or otherwise
            distribute the materials on this Site unless specifically authorized in
            writing by PowerSchool to do so.
            <strong>Retention policy</strong>
            The data you provide in the PowerSchool application is deleted from our
            database, when you delete the application. In the case you remain an active
            user, your data is retained for as long as your account is active in the
            application. For cases where the user has not accessed the application for
            three (3) months nor has deleted their account, PowerSchool will consider
            those accounts as “inactive”. For such inactive accounts, PowerSchool will
            retain the data for ten (10) years. We retain the data of inactive use
            accounts for up to 10 years in this application to support the users’ ability
            to leverage their historical career profile and assessment data for future
            consideration.
            <strong>Data Privacy</strong>
            By accepting the Terms of Use (ToU) and accessing the site, you authorize
            PowerSchool to collect and process your data as necessary to deliver the
            product´s services. PowerSchool guarantees that all data collection and
            processing activities comply with applicable laws and regulations. For
            detailed information on how PowerSchool safeguards your data privacy, please
            refer to our Data Privacy Agreement for Publicly Accessible Services (DPA).
            [link the B2C DPA].
            <strong>User Restrictions</strong>
            Users accessing Headed2 services have the following restrictions:
            Modifications of any materials on this Site or use of the materials for any
            purpose other than as contemplated in this Site is a violation of
            PowerSchool’s copyright and proprietary rights. Unless expressly allowed by
            Headed2, you may not reproduce, upload, post, transmit, download, or
            distribute any part of this site other than printing out or downloading
            portions of the text and images for your own personal, non- commercial use,
            without written approval of PowerSchool. You will not use this Site for any
            purpose that is unlawful or prohibited by this ToU. You agree not to upload,
            post, transmit, publish, or distribute or use any material or information in
            this Site that is unlawful, or which may potentially be perceived as being
            harmful, threatening, or objectionable in any manner that could damage,
            disable, overburden, or impair this Site or interfere with any other party’s
            use and enjoyment of this Site. You agree not to obtain or attempt to obtain
            through this Site any materials or information not intentionally made
            available to you through this Site.
            <strong>Termination</strong>
            PowerSchool reserves the right at any time, and from time to time, to modify
            or discontinue, temporarily or permanently, this Site or any of its services,
            or any part thereof, with or without notice. You agree that PowerSchool will
            not be liable to you or any third party for any modification, suspension, or
            discontinuation of this Site or any services, or any part thereof. Further,
            PowerSchool reserves the right to terminate your username and password and
            your use of this site or any of the services if PowerSchool believes that you
            have violated or acted inconsistently with this ToU or for any other reason.
            You agree that any termination of your access to this site or any services
            under any provision of this ToU may be affected with or without prior notice
            and acknowledge and agree that PowerSchool may immediately deactivate or
            delete your username and password and all related information and files under
            your username and password and/or bar any further access to this site or any
            services. Further, you agree that PowerSchool will not be liable to you or any
            third party for any termination of your access to this site or any of its
            services.
            <strong>Links to Other Sites</strong>
            This Site may provide links to third party websites or resources. Because
            PowerSchool does not control such websites and resources, you acknowledge and
            agree that PowerSchool is not responsible or liable for the content, products
            or performance of such third-party websites and resources, and you hereby
            irrevocably waive any claim against PowerSchool with respect to such websites
            and resources. PowerSchool acts as a facilitator in such cases and may not
            have direct control over the third-party services. PowerSchool reserves the
            right to terminate any link at any time without notice. The inclusion of a
            link to such another website or resource does not constitute or imply an
            endorsement, authorization, sponsorship, or affiliation by PowerSchool of that
            website or resource, or any products or services provided therein. The
            information practices of those websites are not covered by this Site’s Privacy
            Policy or any other policies or terms applicable to this Site. We recommend
            that you review any terms of use and privacy policy of any linked third-party
            website before providing any information to that website or using its products
            and services. Domain names and trademarks of any linked website, and all
            content of such linked website, are the sole property of their respective
            owners. On using such third-party sites, you agree or may be manually required
            to share your details with such vendor. PowerSchool will not be party to any
            legal proceedings between a user and a party contracted through the site. In
            case PowerSchool is implicated in any legal proceedings, costs will be
            recovered from the party that names PowerSchool/Headed2. PowerSchool, however,
            will abide with any court order served on it through due process. Please note
            that this Site may also provide links to other sites (PowerSchool, partners,
            or third parties) brought to you by PowerSchool. The Terms of Use of other
            PowerSchool sites may vary from this Site. We recommend that you review the
            Privacy Statement, ToU that may apply to other PowerSchool sites if you should
            choose to use such sites.
            <strong>Copyright and Trademark Notices</strong>
            The entire content of this Site and any supporting software are the
            proprietary property of PowerSchool and/or its licensors and are protected by
            United States and international copyright and other intellectual property
            laws. The reproduction, redistribution, modification, or publication of any
            part of this Site without the express written consent of PowerSchool and/or
            its licensors is strictly prohibited. You agree not to display, disparage,
            dilute, or taint our trademarks or use any confusing similar marks or use our
            trademarks in such a way that would misrepresent the ownership of such marks.
            Any permitted use of our trademarks by you shall be to the benefit of
            PowerSchool. If you submit any concepts, ideas, comments, manuscripts,
            illustrations, or other materials in connection with this Site, you do so
            without any restriction or expectation of confidentiality as to the parts of
            such submission that is not personally identifiable to the registered member.
            We will have no financial or other obligations to you when you submit such
            information, nor shall you assert any proprietary (including copyright) or
            moral right of any kind with respect to such submissions. PowerSchool will
            have the right to use, publish, reproduce, modify, transmit, download, upload,
            post, display, or otherwise distribute in any form and media, now known or
            developed hereafter, your submissions without notice or compensation to you.
            Any suggestions received through ‘contact us’ shall become the property of
            PowerSchool without any obligation, and you shall not be entitled to any claim
            or compensation under any circumstances.
            <strong>Disclaimer of Warranties</strong>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT: YOUR USE OF THIS SITE IS AT YOUR OWN
            RISK. THIS SITE IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS.
            POWERSCHOOL EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
            IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON- INFRINGEMENT.
            POWERSCHOOL MAKES NO WARRANTY THAT: THIS SITE WILL MEET YOUR REQUIREMENTS,
            THIS SITE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE, THE RESULTS
            THAT MAY BE OBTAINED FROM THE USE OF THIS SITE WILL BE ACCURATE OR RELIABLE,
            THE QUALITY OF ANY PRODUCTS, SERVICES, INFORMATION, OR OTHER MATERIAL
            PURCHASED OR OBTAINED BY YOU THROUGH THIS SITE WILL MEET YOUR EXPECTATIONS,
            AND ANY ERRORS OR DEFECTS IN THIS SITE WILL BE CORRECTED. ANY MATERIAL
            UPLOADED/DOWNLOADED OR OTHERWISE OBTAINED, FROM THIS SITE IS DONE AT YOUR OWN
            DISCRETION AND RISK; POWERSCHOOL SHALL NOT BE LIABLE, AND YOU WILL BE SOLELY
            RESPONSIBLE, FOR ANY AND ALL LOSS, OR CORRUPTION OF DATA UPLOADED OR INPUTTED
            BY YOU THROUGH THE USE OF THIS SITE, AND ALL SERVICING, REPAIR, OR CORRECTION
            AND ANY DAMAGE TO YOUR HARDWARE AND SOFTWARE THAT MAY RESULT FROM THE USE OF
            THIS SITE.
            <strong>Limitation of Liability</strong>
            Headed2.com is only a venue. This site acts as a venue for career exploration
            and planning system, wherein Explorers, are provided with tools that help them
            develop career exploration skills, identify next steps, and plan for their
            future. Explorers can optionally connect with Navigators, who can help
            facilitate that process and guide their journey. PowerSchool is not involved
            in the actual transaction between Explorers and Navigators. You assume all
            risks associated with dealing with other users with whom you come in contact
            through the site and PowerSchool in no event can be held liable for any
            direct, indirect, incidental, consequential, special, exemplary, punitive, or
            any other monetary or other damages, fees, fines, penalties, or liabilities
            arising out of or relating in any way to third-party links accessed through
            this site. As user authentication on the Internet is difficult, PowerSchool
            cannot and does not confirm that each user is who they claim to be. Because
            PowerSchool does not and cannot be involved in user-to-user dealings or
            control the behavior of participants on the site, in the event that you have a
            dispute with one or more users, you release PowerSchool (and our agents and
            employees) from claims, demands and damages (actual and consequential, direct
            and indirect) of every kind and nature, known and unknown, suspected and
            unsuspected, disclosed and undisclosed, arising out of or in any way connected
            with such disputes. If you are a California resident, you waive California
            Civil Code § 1542, which says: “A general release does not extend to claims
            which the creditor does not know or suspect to exist in his favor at the time
            of executing the release, which if known by him must have materially affected
            his settlement with the debtor.“ PowerSchool is under no legal obligation to,
            and generally does not, control the information provided by other users which
            is made available through this site. By its very nature, other people´s
            information may be offensive, harmful, or inaccurate, and in some cases will
            be mislabeled or deceptively labeled. PowerSchool expects that you will use
            caution and common sense when using this site. You acknowledge and agree that
            you are solely responsible for the form, content and accuracy of any
            information placed by you on this site. IN NO EVENT SHALL POWERSCHOOL, OUR
            AFFILIATES, AND/OUR RESPECTIVE SUPPLIERS AND LICENSORS BE LIABLE FOR ANY
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY
            DAMAGES, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE OR DATA, OR OTHER
            INTANGIBLE LOSSES (EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES),
            ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF THIS SITE OR WITH THE
            DELAY OR INABILITY TO USE THIS SITE, OR FOR ANY INFORMATION, SOFTWARE,
            PRODUCTS, AND SERVICES OBTAINED THROUGH THIS SITE, OR OTHERWISE ARISING OUT OF
            THE USE OF THIS SITE, WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY, OR
            OTHERWISE, OUR AFFILIATES, AND/OR OUR RESPECTIVE SUPPLIERS AND LICENSORS HAS
            BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. BECAUSE SOME
            STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR
            CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO
            YOU. IN NO EVENT WILL THE AGGREGATE LIABILITY OF POWERSCHOOL, OUR AFFILIATES,
            AND OUR RESPECTIVE SUPPLIERS AND LICENSORS FOR ANY DAMAGES ARISING OUT OF OR
            RELATED TO ANY DEFAULT HEREUNDER, REGARDLESS OF THE FORM OF THE ACTION, EXCEED
            THE AMOUNT OF FEES ACTUALLY PAID BY YOU FOR USE OF THIS SITE.
            <strong>Indemnification</strong>
            You agree to indemnify and hold PowerSchool and its subsidiaries, affiliates,
            officers, agents, directors, licensors, contractors, and employees harmless
            from any claim or demand, including reasonable attorneys’ fees, made by any
            third party due to or arising out of your use of this Site, your connection to
            this Site, your violation of these Terms of Use, or your violation of any
            rights of another User.
            <strong>General</strong>
            This Terms of Use and the Privacy Statement constitute the entire agreement
            between you and PowerSchool and shall govern your use of this Site and
            supersede any prior agreements between you and PowerSchool concerning this
            Site. You also may be subject to additional terms and conditions that may
            apply when you use affiliated services, third-party content, or third-party
            software. These Terms of Use and the relationship between you and PowerSchool
            will be governed by the laws of the State of California without regard to its
            conflict of law provisions. The United Nations Convention on Contracts for the
            International Sale of Goods is expressly disclaimed. The failure of
            PowerSchool to exercise or enforce any right or provision of these Terms of
            Use shall not constitute a waiver of such right or provision. If any provision
            of these Terms of Use is found by a court of competent jurisdiction to be
            invalid, the parties nevertheless agree that the court should endeavor to give
            effect to the parties´ intentions as reflected in the provision, and the other
            provisions of these Terms of Use remain in full force and effect. You agree
            that regardless of any statute or law to the contrary, any claim or cause of
            action arising out of or related to use of this site or these Terms of Use
            must be filed within one (1) year after such claim or cause of action arose or
            be forever barred. You agree that no joint venture, partnership, employment,
            or agency relationship exists between you and PowerSchool or any of our
            affiliates or suppliers as a result of this agreement or use of this site.
            PowerSchool may send email notification of recent events of interest to our
            visitors. You may opt out of these email notifications by contacting us
            through our e-mail address at support@powerschool.com. PowerSchool reserves
            the right to contact you via email to notify you of important system changes.
            Any rights not expressly granted herein are reserved. Please report any
            violations of these Terms of Use to{' '}
            <a href="https://forms.office.com/pages/responsepage.aspx?id=qv1uquImqk6i2pFlS5-u2qa02Mvc-thCoxzMzOnmHcJUOFNaUUpJMURJMUtJV1VIOUU3V0U3TlhKMCQlQCN0PWcu">
              Data Subject Access Form
            </a>
            <strong>Digital Millennium Copyright Act Compliance</strong>
            If you have any copyright concerns about any materials posted on this Site or
            through the Services by others, please let us know. We comply with the
            provisions of the Digital Millennium Copyright Act (“DMCA”) applicable to
            Internet service providers (17 U.S.C. § 512). Unless otherwise stated in any
            specific DMCA designation provided by PowerSchool, please provide us with
            written notice (“Notice”) by contact- using our Designated Agent at the
            following address: DMCA Designated Agent PowerSchool Group LLC 150 Parkshore
            Dr Folsom, CA 95630 email: support@powerschool.com To be effective, the Notice
            must include the following: A physical or electronic signature of the owner,
            or a person authorized to act on behalf of the owner, (“Complaining Party”) of
            an exclusive right that is allegedly being infringed upon; Information
            reasonably sufficient to permit PowerSchool to contact the Complaining Party,
            such as an address, telephone number, and if available, an electronic mail
            address; Identification of the allegedly infringing material on the
            PowerSchool Site (“Infringing Material”), and information reasonably
            sufficient to permit PowerSchool to locate such material on the PowerSchool
            Site; Identification of the copyrighted work claimed to have been infringed
            upon (“Infringed Material”), or if multiple copyrighted works at a single
            PowerSchool Site are covered by a single Notice, a list of each copyrighted
            work claimed to have been infringed (please be specific as to which Infringing
            Material is infringing on which Infringed Material); A statement that the
            Complaining Party has a good faith belief that use of Infringing Material in
            the manner complained of is not authorized by the copyright owner, its agent,
            or the law; and A statement that the information in the Notice is accurate,
            and under penalty of perjury, that the Complaining Party is the owner or is
            authorized to act on behalf of the owner of an exclusive right that is
            allegedly infringed.
            <strong>Violations</strong>
            Please <a href="https://www.powerschool.com/company/contact/">
              Contact Us
                   </a>{' '}
            to report any violations of the ToU. PowerSchool Group LLC.
          </Text>
        </Page.Content>
      </Page.Layout>
      <Page.Bottom />
    </Page>
  )
}

export { TermsOfUse }
